import * as React from 'react';

import { ProjectsBlock } from '../../components/ProjectsBlock';
import { OFFER_CARD_PATH_REGEX } from '../../constants/regex';
import { trackLinkOnCardClick } from './tracking';

export const ProjectsBlockContainer: React.FC = () => {
  const handleLinkClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    const href = event.currentTarget.href;

    if (OFFER_CARD_PATH_REGEX.test(window.location.pathname)) {
      trackLinkOnCardClick(href);

      return;
    }
  };

  return <ProjectsBlock onLinkClick={handleLinkClick} />;
};
